/// <reference path="../../../scripts/typings/angular-ui/angular-ui-router.d.ts" />

export function initialize(module: ng.IModule) {
    module.config(configure);

    configure.$inject = ["$stateProvider", "$urlRouterProvider"];
}

function configure(
    $stateProvider: ng.ui.IStateProvider,
    $urlRouterProvider: ng.ui.IUrlRouterProvider) {

    $stateProvider
        .state("app", {
            url: "",
            abstract: true,
            views: {
                "shell-view@": {
                    template: require('./shell.html')
                }
            }
        });

    // On invalid routes redirect to dashboard "/activities/daily"
    $urlRouterProvider.otherwise("/home");
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/layout/layout.routes.ts